module.exports = __webpack_public_path__ + "img/sixpackcarrier96.d0ca892f.jpg";